import React, { useState, useEffect } from "react";
import classNames from "classnames";
import classes from "./RunningText.module.scss";
import images from "../../../commons/images";
import history from "../../../misc/history";
import { Link } from "react-router-dom";
import { http } from "../../../misc/http";

export default ({ dataText,goDetail }) => {
  const [active, setActive] = useState(0);
  const [eventList, setEventList] = useState([]);
  const prevNav = () => {
    if (active !== 0) {
      setActive(active - 1);
    }
  };
  const nextNav = () => {
    if (active !== eventList.length - 1) {
      setActive(active + 1);
    }
  };

  const getEventWebinar = async () => {
    let params = {
      method: "GET",
      path: 'events?status=publish',
      // path: 'events?eventType=webinar',
      showMessage: false,
    };
    let { data } = await http(params);
    if (data.status === true && data.code === 200) {
      setEventList(data.data)
    }
  };

  useEffect(() => {
    getEventWebinar()
  },[])
  if(eventList.length > 0)
  return (
    <section className={classes.runningText}>
      <div className={classNames("container", classes.container)}>
        <p
          style={{
            margin: "16px 18px 13px 19px",
            color: "#DADADA",
            letterSpacing: 2,
          }}
          className="p-nunito"
        >
          NEWSFLASH
        </p>
        <div style={{ height: 34, width: 1, backgroundColor: "#FFFFFF", marginRight: 19 }} />
        <marquee scrollDelay={50} className="p-nunito">{eventList[active].title}</marquee>
        <div className={classes.moreBtn}>
          <Link className="nav-link" to={`event_detil/${eventList[active]._id}`}>
            Selengkapnya
          </Link>
        </div>
        <div
          className={classNames(classes.btnAction, classes.prev, {
            [classes.disabled]: active === 0,
          })}
          onClick={prevNav}
        >
          <img src={images.arrowRight} alt="prev" />
        </div>
        <div
          className={classNames(classes.btnAction, classes.next, {
            [classes.disabled]: active === eventList.length - 1,
          })}
          onClick={nextNav}
        >
          <img src={images.arrowRight} alt="next" />
        </div>
      </div>
    </section>
  );

  return null
};
